
import { defineComponent, onMounted, onUnmounted, SetupContext } from "vue";
import Modal from "@/components/Modal.vue";

type Props = {
  imgSrc: String;
};

export default defineComponent({
  name: "PickupModal",
  components: {
    Modal,
  },
  props: {
    imgSrc: {
      type: String,
      default: "",
    },
  },
  emits: ["img-src", "close"],
  setup(props: Props, context: SetupContext) {
    onMounted(() => {});

    onUnmounted(() => {});

    function closeModal() {
      context.emit("close");
    }

    return {
      closeModal,
    };
  },
});
